import { Stack, TextField, Typography } from "@mui/material";
import { Button, Box } from "@mui/material";
import { useState } from "react";
import { useContext } from "react";
import ApiContext from "api/ConsigazApi";
import { weightFormat } from "../../../../../utils/Masks/Masks";
import meterImg from "assets/meterImg.png";

export default function ConsumptionDoubts({ invoice }) {
  const { ConsigazApi } = useContext(ApiContext);
  const [valueMeter, setValueMeter] = useState("");

  const startDate = new Date(
    `${invoice["tt-dados-gerais"][0]["dt-leitura-ant"]} 00:00:00`
  ).toLocaleDateString("pt-br");
  const endDate = new Date(
    `${invoice["tt-dados-gerais"][0]["dt-leitura"]} 00:00:00`
  ).toLocaleDateString("pt-br");

  return (
    <>
      <Stack direction={"row"} alignItems={"center"} mb={"24px"}>
        <Typography fontSize={"36px"} fontWeight={800} color={"#03A9F5"}>
          Analisar leitura/numeração
        </Typography>
      </Stack>
      <Stack direction={"row"} gap={"32px"}>
        <Stack>
          <Typography fontSize={"14px"} fontWeight={500} color="#636363">
            Período de consumo
          </Typography>
          <Typography
            fontSize={"24px"}
            fontWeight={700}
            color={"#053462"}
            mt={"2px"}
          >
            {startDate} a {endDate}
          </Typography>
        </Stack>
        <Stack>
          <Typography fontSize={"14px"} fontWeight={500} color="#636363">
            Leitura inicial - final
          </Typography>
          <Typography
            fontSize={"24px"}
            fontWeight={700}
            color={"#053462"}
            mt={"2px"}
          >
            {weightFormat(invoice["tt-dados-gerais"][0]["leitura-ant"], "")} a{" "}
            {weightFormat(invoice["tt-dados-gerais"][0]["leitura-atual"], "")}
          </Typography>
        </Stack>
        <Stack>
          <Typography fontSize={"14px"} fontWeight={500} color="#636363">
            Consumo em Kg
          </Typography>
          <Typography
            fontSize={"24px"}
            fontWeight={700}
            color={"#053462"}
            mt={"2px"}
          >
            {weightFormat(invoice["tt-dados-gerais"][0]["kg"])}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction={"row"} mt={"65px"} gap={"24px"}>
        <Stack>
          <Typography
            fontSize={"32px"}
            fontWeight={700}
            color="#03A9F5"
            mt={"66px"}
            sx={{
              lineHeight: 1,
            }}
          >
            Informe a leitura de seu medidor
          </Typography>
          <Typography
            fontSize={"16px"}
            fontWeight={500}
            color="#636363"
            mt={"16px"}
          >
            Informe a leitura/numeração que marca no seu medidor como na imagem
            ao lado
          </Typography>
          <TextField
            variant="standard"
            placeholder="leitura/numeração"
            color="secondary"
            value={valueMeter}
            onChange={(e) => setValueMeter(e.target.value)}
            sx={{ textAlign: "center", color: "#fff", mt: "64px" }}
          />
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            sx={{
              height: "55px",
              color: "#fff",
              mt: "8px",
            }}
          >
            Analisar
          </Button>
        </Stack>
        <Stack
          border={"2px solid #05346299"}
          borderRadius={"16px"}
          p={"24px"}
          width={"55%"}
        >
          <Typography fontSize={"20px"} fontWeight={700} color="#053462">
            Onde encontro minha leitura/numeração?
          </Typography>
          <Typography
            fontSize={"13px"}
            fontWeight={500}
            color="#636363"
            mt={"8px"}
          >
            Sua leitura numérica encontra-se na parte superior do medidor. Sendo
            um conjunto numérico composto por 8 dígitos.
          </Typography>
          <Stack alignItems={"center"} mt={"42px"}>
            <Box
              component="img"
              src={meterImg}
              alt="Exemplo de leitura no medidor"
              sx={{
                height: "262px",
                width: "189px",
              }}
            />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}
